// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__HIjUD","importantInfo":"styles_importantInfo__3dYXD"};